import ky, { HTTPError, Options } from 'ky';

import { basePath as BASE_PATH } from '@/constants/api';

import { AppError } from './appError';

type ApiOptions = {
  basePath?: string;
  options?: Options;
};

class Api {
  basePath: string;
  http: ReturnType<typeof ky.create>;

  constructor({ basePath = BASE_PATH, options = {} }: ApiOptions) {
    this.http = ky.create({ ...options });
    this.basePath = basePath;
  }

  async get<R>(url: string, options?: Options) {
    try {
      const response = await this.http
        .get<R>(`${this.basePath}${url}`, options)
        .json();
      return response;
    } catch (e) {
      if (e instanceof HTTPError) {
        const error = new AppError(e);
        await error.json();
        throw error;
      }

      throw e;
    }
  }

  async post<B extends object, R>(url: string, json: B, options?: Options) {
    try {
      const response = await this.http
        .post<R>(`${this.basePath}${url}`, { json, ...options })
        .json();
      return response;
    } catch (e) {
      if (e instanceof HTTPError) {
        const error = new AppError(e);
        await error.json();
        throw error;
      }

      throw e;
    }
  }

  async put<B extends object, R>(url: string, json: B, options?: Options) {
    try {
      const response = await this.http
        .put<R>(`${this.basePath}${url}`, { json, ...options })
        .json();
      return response;
    } catch (e) {
      if (e instanceof HTTPError) {
        const error = new AppError(e);
        await error.json();
        throw error;
      }

      throw e;
    }
  }

  async delete<B extends object, R>(url: string, json: B, options?: Options) {
    try {
      const response = await this.http
        .delete<R>(`${this.basePath}${url}`, { json, ...options })
        .json();
      return response;
    } catch (e) {
      if (e instanceof HTTPError) {
        const error = new AppError(e);
        await error.json();
        throw error;
      }

      throw e;
    }
  }

  extend(options: Options) {
    return this.http.extend(options);
  }
}

export default Api;
